import type { SearchSchemaInput } from '@tanstack/react-router';

import {
  InvoiceListQuerySchema,
  type Currency,
  type InvoiceListQuery,
} from '../../shared/invoice.ts';

export type InvoiceWorkspaceSearch = Pick<InvoiceListQuery, 'page' | 'pageSize'> & {
  currency?: Currency;
  year?: number;
};

export type InvoiceWorkspaceSearchInput = Partial<InvoiceWorkspaceSearch> &
  SearchSchemaInput &
  Record<string, unknown>;

export function validateInvoiceWorkspaceSearch(
  search: InvoiceWorkspaceSearchInput,
): InvoiceWorkspaceSearch {
  const parsed = InvoiceListQuerySchema.safeParse({
    currency: search.currency,
    year: search.year,
    page: search.page,
    pageSize: search.pageSize,
  });
  if (parsed.success) return parsed.data;
  return InvoiceListQuerySchema.parse({});
}
